import { selectToolState } from "@/lib/state/selectors/tool-selectors";

import {
  GenericTool,
  GenericToolConstructorArgs,
  ToolEventListenerArgs,
} from "./generic";

export class RectangleTool extends GenericTool {
  active = false;
  x: number | null;
  y: number | null;
  colour: string;
  size: number;

  constructor(args: GenericToolConstructorArgs) {
    super(args);
    this.x = null;
    this.y = null;
    this.colour = "#f00";
    this.size = 1;
  }

  onStart({ coords }: ToolEventListenerArgs) {
    const { size, colour, opacity } = selectToolState();
    const [x, y] = coords;
    this.x = x;
    this.y = y;
    this.active = true;
    this.colour = colour;
    this.size = size;
    this.opacity = opacity;

    this.reset();
    this.undoStackPush();
  }

  onMove({ coords }: ToolEventListenerArgs) {
    if (!this.active || this.x === null || this.y === null) return;

    const [x, y] = coords;
    if (x === this.x && y === this.y) return;

    this.offscreenCtx.clearRect(
      0,
      0,
      this.offscreenCtx.canvas.width,
      this.offscreenCtx.canvas.height,
    );
    this.offscreenCtx.fillStyle = this.colour;
    this.offscreenCtx.fillRect(this.x, this.y, x - this.x, y - this.y);
    this.paintToVisible();
  }

  onEnd() {
    this.active = false;
    this.x = null;
    this.y = null;
    this.commitMerged();
  }
}
